<template>
    <b-tabs class="internship-database-global-settings-tab apprentice-tab"
            content-class="internship-index-content">
        <b-tab :title="$t('internship.internship_bank')" active>
            <design-2021-internship-database-index-component :internships-in="internships"
                                                             :organisations-in="organisationsIn"
                                                             :internship-duration-tags-in="internshipDurationTags">
            </design-2021-internship-database-index-component>
        </b-tab>
        <b-tab :title="$t('internship.internship_duration')">
            <design-2021-internship-duration-tags-index-component
            :internship-duration-tags-in="internshipDurationTags">
            </design-2021-internship-duration-tags-index-component>
        </b-tab>
    </b-tabs>
</template>

<script>
import {ords} from '../../../app';

const internshipOrds = ords.use('internship')
const internshipDurationTagOrds = ords.use('internshipDurationTag')
export default {
    name: "design-2021-internship-database-tabs-component",
    props: ['internshipsIn', 'organisationsIn','internshipDurationTagsIn'],
    data() {
        return {
            internships: [],
            internshipDurationTags: [],
        }
    },
    mounted() {
        internshipOrds.add(this.internshipsIn);
        internshipOrds
            .with('internship_duration_tags')
            .get().subscribe((internships) => {
            this.internships = internships;
        })
        internshipDurationTagOrds.add(this.internshipDurationTagsIn);
        internshipDurationTagOrds
            .get().subscribe((tag) => {
            this.internshipDurationTags = tag;
        })
    }
}
</script>

<style scoped>

</style>
